import Vue from 'vue'
import $ from 'jquery'
import axios from 'axios'
import Pusher from 'pusher-js'
//import Echo from 'laravel-echo'
import VueTimeago from 'vue-timeago'

Vue.use(VueTimeago, {
  locale: 'en',
  locales : {
  	ja: require('date-fns/locale/ja'),
  	en: require('date-fns/locale/en')
  	/* 'en-US': require('json-loader!vue-timeago/locales/en-US.json') */
  /*locales: { 'en-US': require('json-loader!vue-timeago/locales/en-US.json') }*/
  }
})

window.Vue = Vue
window.Pusher = Pusher
window.jQuery = window.$ = $

axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

require('bootstrap-sass/assets/javascripts/bootstrap')



window.axios = axios
